import { render, staticRenderFns } from "./amostrasstatus.vue?vue&type=template&id=5d3619eb"
import script from "./amostrasstatus.vue?vue&type=script&lang=js"
export * from "./amostrasstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports